import { render, staticRenderFns } from "./HaulageJobPage.vue?vue&type=template&id=3bb80305&scoped=true&"
import script from "./HaulageJobPage.vue?vue&type=script&lang=js&"
export * from "./HaulageJobPage.vue?vue&type=script&lang=js&"
import style0 from "./HaulageJobPage.vue?vue&type=style&index=0&id=3bb80305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb80305",
  null
  
)

export default component.exports